import StatusScreen from "@/components/status-screen";
import { createFileRoute } from "@tanstack/react-router";
import { Check } from "lucide-react";

export const Route = createFileRoute("/_private/billing/success")({
  component: BillingSuccess,
});

function BillingSuccess() {
  return (
    <StatusScreen
      icon={<Check />}
      iconWrapperClassName="text-green-500 bg-green-50 dark:bg-green-900/20 dark:text-green-400"
      title="Payment Successful"
      description="Thank you for your payment! Your transaction has been processed successfully. A confirmation email with your receipt has been sent to your inbox."
      variant="link-button"
      buttonText="View Billing Details"
      buttonLink="/billing"
      wrapperClass="min-h-[calc(100vh-150px)] flex justify-center items-center w-full"
    />
  );
}
